import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { serializeCoursesState } from '@/js/core/utils/courses-url-state';
import { ownsUrl } from '@/js/core/utils/modal-route';

// Keeps the URL in sync with the Courses page view + filters so users can bookmark a
// view. Mirrors useCalendarUrlState: a clean landing (no query) stays parameter-free
// until the first interaction; deep links normalize on mount.
export function useCoursesUrlState({ activeView, selectedFilters }) {
  const route = useRoute();
  const hadInitialParams = window.location.search.length > 1;

  watch(
    [activeView, selectedFilters],
    () => {
      if (!ownsUrl(route)) {
        return;
      }

      const qs = serializeCoursesState({
        view: activeView.value,
        filters: selectedFilters.value,
      });
      window.history.replaceState(window.history.state, '', `${window.location.pathname}?${qs}`);
    },
    { deep: true, immediate: hadInitialParams }
  );
}
